import React from 'react';
import {
  FieldError,
  Label,
  RadioGroup as RACRadioGroup,
  RadioGroupProps as RACRadioGroupProps,
  Text,
  ValidationResult,
} from 'react-aria-components';

export type RadioGroupProps = {
  /**
   * A label for the radio group.
   */
  label?: string;
  /**
   * Description or additional information about the radio group.
   */
  description?: string;
  /**
   * A label, indicating that the field is required.
   */
  labelRequired?: string;
  /**
   * An error message to display when validation fails.
   */
  errorMessage?: string | ((validation: ValidationResult) => string);
  /**
   * Children elements to render as radio buttons.
   */
  children?: React.ReactNode;
  /**
   * Indicates whether the input field is required or not.
   */
  isRequired?: boolean;
} & RACRadioGroupProps;

const RadioGroup = ({
  label,
  labelRequired,
  description,
  errorMessage,
  children,
  isRequired,
  ...props
}: RadioGroupProps) => {
  return (
    <RACRadioGroup {...props}>
      <Label>
        {label}
        {isRequired && <Text slot="description">{labelRequired}</Text>}
      </Label>
      <FieldError>{errorMessage}</FieldError>
      {children}
      {description && <Text slot="description">{description}</Text>}
    </RACRadioGroup>
  );
};

export default RadioGroup;
